<template>
  <div id="app">
    <main class="closed-page">
      <div class="card shadow closed-card">
        <div class="card-body">
          <img
            class="moon"
            src="https://amble.studio/wp-content/uploads/2021/08/Moon-icon.png"
            alt="Moon"
          />
          <h1>ArribaTown is now closed</h1>
          <p class="thanks">Thanks for playing!</p>
        </div>
      </div>
    </main>
  </div>
</template>

<script>
export default {
  name: "app",
  metaInfo() {
    return {
      title: "Arriba Town",
      meta: [
        {
          property: "description",
          content: "ArribaTown is now closed. Thanks for playing!",
          vmid: "description",
        },
        {
          property: "og:title",
          content: "Arriba Town",
          vmid: "og:title",
        },
        {
          property: "og:description",
          content: "ArribaTown is now closed. Thanks for playing!",
          vmid: "og:description",
        },
        {
          property: "og:image",
          content:
            "https://amble.studio/wp-content/uploads/2021/08/Moon-icon.png",
          vmid: "og:image",
        },
        {
          property: "og:url",
          content: "https://arribatown.aimbig.com.au/",
          vmid: "og:url",
        },
        {
          property: "twitter:card",
          content: "summary",
          vmid: "twitter:card",
        },
        {
          property: "og:site_name",
          content: "Arriba Town",
          vmid: "og:site_name",
        },
        {
          property: "twitter:image:alt",
          content: "Arriba Town",
          vmid: "twitter:image:alt",
        },
      ],
    };
  },
  mounted() {
    document.dispatchEvent(new Event("x-app-rendered"));
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@400;600&display=swap");

html,
body {
  height: 100%;
}

body {
  background: #f4f5f7;
  margin: 0;
  color: #333;
  font-family: "Poppins", sans-serif;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  min-height: 100vh;
  padding: 0;
  font-family: "Poppins", sans-serif;
  color: #333;
  background: #f4f5f7;
}

.closed-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem 1rem;
  text-align: center;
}

.closed-card {
  max-width: 420px;
  width: 100%;
  background: #fff;
  border: none;
  color: #333;
}

.closed-card .card-body {
  padding: 1.75rem 1.5rem 1.6rem;
}

.moon {
  display: block;
  width: 88px;
  max-width: 28%;
  height: auto;
  margin: 0.15rem auto 0.85rem;
}

.closed-card h1 {
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  font-size: 1.65rem;
  line-height: 1.3;
  color: #d23b3b;
  text-shadow: none;
  margin: 0 0 0.45rem;
}

.thanks {
  margin: 0;
  color: #333;
  font-size: 0.95rem;
}
</style>
